<template>
  <el-upload
    drag
    :action="uploadUrl"
    multiple
    name="photo"
    :headers="{ Authorization: authorization }"
    :on-error="(event) => handleError(event)"
  >
    <el-icon class="el-icon--upload"><UploadFilled /></el-icon>
    <div class="el-upload__text" style="margin-top: 0">Drop file here or <em>click to upload</em></div>
    <template #tip>
      <div class="el-upload__tip">jpg/png files with a size less than 10mb</div>
    </template>
  </el-upload>
</template>
<script>
import { UploadFilled } from '@element-plus/icons-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    UploadFilled,
  },
  props: {
    uploadUrl: {
      required: true,
      type: String,
    },
  },
  emits: ['media-url-error'],
  computed: {
    ...mapGetters('auth', ['authorization']),
  },
  methods: {
    handleError(error) {
      this.$emit('media-url-error', JSON.parse(error.message))
    },
  },
}
</script>
